import { render, staticRenderFns } from "./FramerateGraph.vue?vue&type=template&id=65e2369a&scoped=true&"
import script from "./FramerateGraph.vue?vue&type=script&lang=js&"
export * from "./FramerateGraph.vue?vue&type=script&lang=js&"
import style0 from "./FramerateGraph.vue?vue&type=style&index=0&id=65e2369a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e2369a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65e2369a')) {
      api.createRecord('65e2369a', component.options)
    } else {
      api.reload('65e2369a', component.options)
    }
    module.hot.accept("./FramerateGraph.vue?vue&type=template&id=65e2369a&scoped=true&", function () {
      api.rerender('65e2369a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/views/perf/FramerateGraph.vue"
export default component.exports